import { api } from "roboflex-thalamus-request-handler";
import { PersonModel } from "../model/PersonModel";

export class PersonDataSource {
  async getPeople() {
    let rawData = await api.get("pessoa");
    return rawData.data.map((ele) => PersonModel.fromJson(ele));
  }
}
